module.exports = __webpack_public_path__ + "static/line-crew-31e0eefba74023f45b4a06fc8e816788.jpg";